import { motion } from "framer-motion";
import { ArrowUpRight, Linkedin, Instagram, Twitter } from "lucide-react";
import Logo from "@/components/site/Logo";

const cols = [
  {
    title: "Company",
    links: [
      { label: "About", href: "#about" },
      { label: "Capabilities", href: "#capabilities" },
      { label: "Gallery", href: "#gallery" },
      { label: "Contact", href: "#contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Procurement", href: "#services" },
      { label: "Supply", href: "#services" },
      { label: "Interior Design", href: "#services" },
      { label: "Project Execution", href: "#services" },
      { label: "Business Support", href: "#services" },
    ],
  },
  {
    title: "Contact",
    links: [
      { label: "nsoulventures1@gmail.com", href: "mailto:nsoulventures1@gmail.com" },
      { label: "+91 89780 42358", href: "tel:+918978042358" },
      { label: "India", href: "#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[var(--nv-navy)] text-[var(--nv-paper)] pt-24 md:pt-32 pb-10 nv-grain overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-5">
            <Logo variant="light" testId="footer-logo" className="mb-8" />
            <h3 className="mt-2 font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight">
              A quieter kind of <span className="italic text-[var(--nv-gold)]">excellence.</span>
            </h3>
            <a href="#contact" className="mt-8 inline-flex btn-gold" data-testid="footer-cta">
              Start a Conversation <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="col-span-6 md:col-span-4 lg:col-span-2">
              <div className="overline text-[var(--nv-paper)]/50 mb-5">{c.title}</div>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="nv-link text-sm text-[var(--nv-paper)]/85 hover:text-[var(--nv-gold)] transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="col-span-12 lg:col-span-1 flex lg:flex-col gap-4">
            <a href="#" className="w-10 h-10 rounded-full border border-[var(--nv-paper)]/30 flex items-center justify-center hover:border-[var(--nv-gold)]" data-testid="social-linkedin"><Linkedin className="w-4 h-4"/></a>
            <a href="#" className="w-10 h-10 rounded-full border border-[var(--nv-paper)]/30 flex items-center justify-center hover:border-[var(--nv-gold)]" data-testid="social-instagram"><Instagram className="w-4 h-4"/></a>
            <a href="#" className="w-10 h-10 rounded-full border border-[var(--nv-paper)]/30 flex items-center justify-center hover:border-[var(--nv-gold)]" data-testid="social-twitter"><Twitter className="w-4 h-4"/></a>
          </div>
        </div>

        {/* Massive wordmark */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.1, ease: [0.7, 0, 0.3, 1] }}
          className="mt-24 md:mt-32 -mx-2 select-none"
          aria-hidden
        >
          <div className="font-serif text-[22vw] md:text-[18vw] leading-[0.88] tracking-tight text-[var(--nv-paper)]">
            Nsoul <span className="italic text-[var(--nv-gold)]">Ventures</span>
          </div>
        </motion.div>

        <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-[var(--nv-line-dark)] pt-8 text-[11px] font-mono uppercase tracking-[0.24em] text-[var(--nv-paper)]/50">
          <span>© Nsoul Ventures — All rights reserved.</span>
          <span>Crafted in India</span>
        </div>
      </div>
    </footer>
  );
}
